/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 16L7.25 13.5M14 16L12.75 13.5M16.5 16V12M17 9C17 9.27614 16.7761 9.5 16.5 9.5C16.2239 9.5 16 9.27614 16 9M17 9C17 8.72386 16.7761 8.5 16.5 8.5C16.2239 8.5 16 8.72386 16 9M17 9H16M7.25 13.5H12.75M7.25 13.5L10 8L12.75 13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				fill="currentColor"
			/>
			<path
				d="M6 16L7.25 13.5M14 16L12.75 13.5M16.5 16V12M17 9C17 9.27614 16.7761 9.5 16.5 9.5C16.2239 9.5 16 9.27614 16 9M17 9C17 8.72386 16.7761 8.5 16.5 8.5C16.2239 8.5 16 8.72386 16 9M17 9H16M7.25 13.5H12.75M7.25 13.5L10 8L12.75 13.5M2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25305 1.84946C5.42957 1.25 6.96971 1.25 10.05 1.25H13.95C17.0303 1.25 18.5704 1.25 19.7469 1.84946C20.7818 2.37677 21.6232 3.21816 22.1505 4.25305C22.75 5.42957 22.75 6.96971 22.75 10.05V13.95C22.75 17.0303 22.75 18.5704 22.1505 19.7469C21.6232 20.7818 20.7818 21.6232 19.7469 22.1505C18.5704 22.75 17.0303 22.75 13.95 22.75H10.05C6.96971 22.75 5.42957 22.75 4.25305 22.1505C3.21816 21.6232 2.37677 20.7818 1.84946 19.7469C1.25 18.5704 1.25 17.0303 1.25 13.95V10.05C1.25 6.96971 1.25 5.42957 1.84946 4.25305C2.37677 3.21816 3.21816 2.37677 4.25305 1.84946ZM10.6708 7.66459C10.5438 7.4105 10.2841 7.25 10 7.25C9.71592 7.25 9.45622 7.4105 9.32918 7.66459L6.57918 13.1646L5.32918 15.6646C5.14394 16.0351 5.29411 16.4856 5.66459 16.6708C6.03507 16.8561 6.48558 16.7059 6.67082 16.3354L7.71353 14.25H12.2865L13.3292 16.3354C13.5144 16.7059 13.9649 16.8561 14.3354 16.6708C14.7059 16.4856 14.8561 16.0351 14.6708 15.6646L13.4208 13.1646L10.6708 7.66459ZM10 9.67705L11.5365 12.75H8.46353L10 9.67705ZM16.5 7.75C15.8096 7.75 15.25 8.30964 15.25 9C15.25 9.69036 15.8096 10.25 16.5 10.25C17.1904 10.25 17.75 9.69036 17.75 9C17.75 8.30964 17.1904 7.75 16.5 7.75ZM17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12V16C15.75 16.4142 16.0858 16.75 16.5 16.75C16.9142 16.75 17.25 16.4142 17.25 16V12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M6 16L7.25 13.5M10 8L12.75 13.5M14 16L12.75 13.5M16.5 16V12M17 9C17 9.27614 16.7761 9.5 16.5 9.5C16.2239 9.5 16 9.27614 16 9M17 9C17 8.72386 16.7761 8.5 16.5 8.5C16.2239 8.5 16 8.72386 16 9M17 9H16M7.25 13.5H12.75M7.25 13.5L8.625 10.75M2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 16L7.25 13.5M14 16L12.75 13.5M16.5 16V12M17 9C17 9.27614 16.7761 9.5 16.5 9.5C16.2239 9.5 16 9.27614 16 9M17 9C17 8.72386 16.7761 8.5 16.5 8.5C16.2239 8.5 16 8.72386 16 9M17 9H16M7.25 13.5H12.75M7.25 13.5L10 8L12.75 13.5M2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.05 1.25C6.96971 1.25 5.42957 1.25 4.25305 1.84946C3.21816 2.37677 2.37677 3.21816 1.84946 4.25305C1.25 5.42957 1.25 6.96971 1.25 10.05V13.95C1.25 17.0303 1.25 18.5704 1.84946 19.7469C2.37677 20.7818 3.21816 21.6232 4.25305 22.1505C5.42957 22.75 6.96971 22.75 10.05 22.75H13.95C17.0303 22.75 18.5704 22.75 19.7469 22.1505C20.7818 21.6232 21.6232 20.7818 22.1505 19.7469C22.75 18.5704 22.75 17.0303 22.75 13.95V10.05C22.75 6.96971 22.75 5.42957 22.1505 4.25305C21.6232 3.21816 20.7818 2.37677 19.7469 1.84946C18.5704 1.25 17.0303 1.25 13.95 1.25H10.05Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.99998 7.25C10.2841 7.25 10.5438 7.4105 10.6708 7.66459L13.4208 13.1646L14.6708 15.6646C14.856 16.0351 14.7059 16.4856 14.3354 16.6708C13.9649 16.8561 13.5144 16.7059 13.3292 16.3354L12.2865 14.25H7.71351L6.6708 16.3354C6.48556 16.7059 6.03505 16.8561 5.66457 16.6708C5.29409 16.4856 5.14392 16.0351 5.32916 15.6646L6.57916 13.1646L9.32916 7.66459C9.4562 7.4105 9.7159 7.25 9.99998 7.25ZM8.46351 12.75H11.5365L9.99998 9.67705L8.46351 12.75ZM15.25 9C15.25 8.30964 15.8096 7.75 16.5 7.75C17.1903 7.75 17.75 8.30964 17.75 9C17.75 9.69036 17.1903 10.25 16.5 10.25C15.8096 10.25 15.25 9.69036 15.25 9ZM16.5 11.25C16.9142 11.25 17.25 11.5858 17.25 12V16C17.25 16.4142 16.9142 16.75 16.5 16.75C16.0858 16.75 15.75 16.4142 15.75 16V12C15.75 11.5858 16.0858 11.25 16.5 11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
